export interface EnumOption {
  key: string;
  value: string;
  parentKeys?: string[];
}

export const optionShownFor = (opt: EnumOption, parentKey?: string): boolean =>
  !!opt.parentKeys && parentKey != null && opt.parentKeys.includes(parentKey);

export const childOptionsForParent = (childOptions: EnumOption[], parentKey?: string): EnumOption[] =>
  parentKey ? childOptions.filter((o) => optionShownFor(o, parentKey)) : [];
